import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

export default class Nav {
	constructor(navRoot) {
		this.navRoot = navRoot;
		this.navMain = this.navRoot.querySelector('.js-nav-main');
		this.navToggleBtn = this.navRoot.querySelector('.js-nav-toggle');
		this.navButtons = Array.from(this.navRoot.querySelectorAll('.js-nav-btn'));
		this.navBarMobile = this.navRoot.querySelector('.js-nav-bar-mobile');
		this.body = document.body;

		this.isAnimating = false;
		this.isOpen = false;

		this.init();
	}

	init() {
		// give body margin bottom to create space for mobile nav bar
		document.documentElement.style.setProperty('--nav-bar-mobile-height', this.navBarMobile.offsetHeight - 1 + 'px');

		this.createTimeline();

		this.navToggleBtn.addEventListener('click', () => this.handleNav());

		document.addEventListener('keydown', (e) => this.handleKeyDown(e));

		// add class to <nav/> when scroll position is not at the top
		this.toggleNavStyling()
	}

	createTimeline() {
		this.tl = gsap
			.timeline({
				paused: true,
				onComplete: () => {
					this.isAnimating = false;
				},
				onReverseComplete: () => {
					this.navMain.hidden = true;
					this.isAnimating = false;
					this.body.classList.remove('no-scroll');
					document.removeEventListener('touchmove', this.preventScrolling);
				},
				onStart: () => {
					this.navMain.hidden = false;
					this.body.classList.add('no-scroll');

					// prevent background from scrolling on ios devices
					document.addEventListener('touchmove', this.preventScrolling, { passive: false });
				},
			})
			.to(this.navMain, {
				duration: 0.3125,
				ease: 'none',
				y: '0',
			})

		this.tlHamburger = gsap
			.timeline({
				paused: true,
				defaults: {
					duration: 0.125,
					ease: 'none',
				},
			})
			.to('.js-hamburger__top', { y: 8.5 })
			.to('.js-hamburger__bottom', { y: -8.5 }, '<')
			.to('.js-hamburger__middle', { stroke: 'rgba(0, 0, 0, 0%)' })
			.to('.js-hamburger__top', {
				y: 8.5,
				rotation: 45,
				transformOrigin: 'center center',
			})
			.to(
				'.js-hamburger__bottom',
				{
					y: -8.5,
					rotation: -45,
					transformOrigin: 'center center',
				},
				'<'
			);
	}

	preventScrolling(e) {
		if (e.target.parentElement.closest('.js-scrollable')) return;
		e.preventDefault();
	}

	handleKeyDown({ key }) {
		if (key !== 'Escape' || !this.isOpen) return;

		this.handleNav('close');
	}

	handleNav() {
		if (this.isAnimating) return;

		this.isAnimating = true;
		this.isOpen = !this.isOpen;

		this.navToggleBtn.setAttribute('aria-expanded', this.isOpen);

		if (this.isOpen) {
			this.tl.play();
			this.tlHamburger.play();
		} else {
			this.tl.reverse();
			this.tlHamburger.reverse();
		}
	}

	toggleNavStyling() {
		if (window.scrollY !== 0) {
			this.navRoot.classList.add('bar--active');
		}

		gsap.matchMedia().add("(min-width: 75em)", () => {
			ScrollTrigger.create({
				onToggle: (self) => {
					if (self.progress > 0) {
						this.navRoot.classList.add('bar--active');
					} else {
						this.navRoot.classList.remove('bar--active');
					}
				}
			});

			return () => {
				this.navRoot.classList.remove('bar--active');
			 };
		});
	}
}
